import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import ApiService from "../ApiService";
import { Col, Card, Button, Modal, Form } from "react-bootstrap";
import MessageDetail from "./MessageDetail";
import { BsArrowClockwise, BsFillCheckCircleFill, BsHourglassSplit, BsFillExclamationCircleFill } from "react-icons/bs";
import { Healing, SupervisedUserCircleOutlined } from "@material-ui/icons";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import ERXModal from "./Modal/eRx/ERXModal";
import ErxService from "../service/erxService";
import './messageView.css';

const MessageView = () => {

  const search = useLocation().search;
  const messageUUID = new URLSearchParams(search).get("messageId");

  const [snackOpen, setSnackOpen] = useState(false);
  const [snackText, setSnackText] = useState("");
  const [snackSeverity, setSnackSeverity] = useState("");
  const [showErxModal, setShowErxModal] = useState(false);
  const [eRxid, setERxId] = useState("");
  const [closeConvModal, setCloseConvModal] = useState(false);
  const [closingInfo, setClosingInfo] = useState(null);

  const handleOpenPrescriptionModal = async () => {
    try {
      const getMessage = await ApiService.getMessage(messageUUID);
      let userData;
      if (getMessage?.data?.fromUser?.addresseeType == "PATIENT") {
        userData = getMessage?.data?.fromUser;
      } else {
        userData = getMessage?.data?.toUsers?.find(item => item.addresseeType == "PATIENT");
      }

      const userDetailRes = await ApiService.getPatientDetailByEmail(userData?.email);
      const userDetail = userDetailRes?.data;
      const photonHealthErxPatientId = userDetailRes?.data?.photonHealthErxPatientId;

      if (photonHealthErxPatientId) {
        setShowErxModal(true);
        setERxId(photonHealthErxPatientId);
      } else {
        if (!userDetail?.birthDate) {
          setSnackOpen(true);
          setSnackSeverity("error");
          setSnackText("Patient DOB is missing");
          return;
        }
        const sexAtBirth = ErxService.determineSexAtBirth(userDetail?.genderAtBirth ?? userDetail?.gender);
        const eRxIdRes = await ApiService.createPatientOnPhoton({
          patientId: userDetail?.subUUID,
          firstName: userDetail?.givenName,
          lastName: userDetail?.familyName,
          dob: userDetail?.birthDate,
          sex: sexAtBirth,
          gender: userDetail?.gender,
          phone: userDetail?.phoneNumber,
          email: userDetail?.email,
          address: {
            name: {
              first: userDetail?.givenName,
              last: userDetail?.familyName
            },
            street1: userDetail?.address?.street_address,
            street2: userDetail?.address?.street_address2,
            postalCode: userDetail?.address?.postal_code,
            country: "USA",
            state: userDetail?.address?.region,
            city: userDetail?.address?.locality
          }
        });
        if (eRxIdRes?.data?.erxPhotonId?.id) {
          const res = await ApiService.updatePhotonERxPatientId(userDetail?.subUUID, eRxIdRes?.data?.erxPhotonId?.id);
          if (res) {
            setShowErxModal(true);
            setERxId(eRxIdRes?.data?.erxPhotonId?.id);
          }
        }
      }
    } catch (err) {
      console.log("err", err);
      setSnackOpen(true);
      setSnackSeverity("error");
      setSnackText(err?.response?.data?.message ?? err?.message);
    }
  };

  const hideErxModal = (orderCreated = false) => {
    setShowErxModal(false);
    if (orderCreated) {
      setSnackOpen(true);
      setSnackSeverity("success");
      setSnackText("Prescription Sent!");
    }
  };

  const onClickViewProfile = async (event, rowData) => {
    try {
      const getMessage = await ApiService.getMessage(messageUUID);
      let userData;
      if (getMessage?.data?.fromUser?.addresseeType == "PATIENT") {
        userData = getMessage?.data?.fromUser;
      } else {
        userData = getMessage?.data?.toUsers?.find(item => item.addresseeType == "PATIENT");
      }
      if (!userData?.userId) {
        const belugaPatientEmail = getMessage?.data?.from;
        const email = belugaPatientEmail.substring(belugaPatientEmail.indexOf("(") + 1, belugaPatientEmail.indexOf(")"));
        console.log("email", email);
        if (!email) {
          setSnackOpen(true);
          setSnackSeverity("error");
          setSnackText("Patient email is missing");
          return;
        }
        const userDetailRes = await ApiService.getPatientDetailByEmail(email);
        console.log("userDetailRes", userDetailRes);
        userData = { ...userDetailRes?.data, userId: userDetailRes?.data?.subUUID };
      }
      console.log("userData", userData);
      window.open(`/PatientProfile?patientId=${userData?.userId}&idType=sub`, "_blank");
    } catch (err) {
      console.log("err", err);
      setSnackOpen(true);
      setSnackSeverity("error");
      setSnackText(err?.response?.data?.message ?? err?.message);
    }
  };

  const handleCloseConversations = async (status, reason, loader) => {
    try {
      loader(true);
      if (!status || !reason) return handleSnackOpen("Please enter a reason", "error");
      await ApiService.addAnnotationToMessage({
        comment: reason,
        status: status,
        msgIds: messageUUID
      });
      setCloseConvModal(false);

      const response = await ApiService.getMessage(messageUUID);
      setClosingInfo({
        latestCommentBy: response?.data?.latestCommentBy || "",
        latestComment: response?.data?.latestComment || "",
        latestStatus: response?.data?.latestStatus || "",
      });
      handleSnackOpen(`Status changed to ${status} successfully`, "success");

    } catch (ex) {
      console.log("error", ex);
      handleSnackOpen("Something went wrong", "error");
    } finally {
      loader(false);
    }
  };

  const handleCloseConvModal = () => {
    setCloseConvModal(false);
  };

  const handleSnackOpen = (text, severity) => {
    setSnackSeverity(severity);
    setSnackText(text);
    setSnackOpen(true);
  };

  const handleSnackClose = () => {
    setSnackOpen(false);
  };

  if (!messageUUID) {
    return (
      <div style={{ marginTop: 50, fontSize: 40 }}>Invalid URL</div>
    );
  }

  return (
    <>
      <Card body className="CardFullBody" style={{ marginTop: 20 }}>
        <Card.Body className="messageDetailBody">
          <Col>
            <div
              style={{
                width: "100%",
                fontSize: "1vw",
                display: "inline-flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 6
              }}
            >
              <div>
                <Button
                  variant="primary"
                  className="message-view-buttons"
                  onClick={() => {
                    handleOpenPrescriptionModal();
                  }}
                >
                  <Healing
                    style={{
                      color: "white",
                      marginRight: 5
                    }}
                  />
                  Send Prescription
                </Button>
                <div style={{ display: "inline-flex", opacity: closingInfo?.latestStatus ? 1 : 0, marginLeft: 10, fontSize: 16 }}>
                  Status: <StatusDone status={closingInfo?.latestStatus} />
                </div>
              </div>
              <div>
                <Button
                  variant="primary"
                  className="message-view-buttons"
                  style={{ marginRight: 10 }}
                  onClick={() => {
                    onClickViewProfile();
                  }}
                >
                  <SupervisedUserCircleOutlined
                    style={{
                      color: "white",
                      marginRight: 5
                    }}
                  />
                  View Profile
                </Button>
                <Button
                  variant="primary"
                  className="message-view-buttons"
                  onClick={() => setCloseConvModal(true)}
                >
                  <BsArrowClockwise style={{ marginRight: 5 }} />
                  Update Status
                </Button>
              </div>
            </div>
            <br />
            {closingInfo && (
              <Form.Label style={{ width: "100%", fontSize: "1vw", display: "inline-flex", justifyContent: "flex-start", alignItems: "center" }}>
                <div>
                  Comment:&nbsp;<b>{closingInfo?.latestComment}</b>
                </div>
                &nbsp;&nbsp;-&nbsp;&nbsp;
                <div>
                  Author:&nbsp;<b>{closingInfo?.latestCommentBy}</b>
                </div>
              </Form.Label>
            )}
            <hr />
          </Col>
          <MessageDetail messageUUID={messageUUID} setClosingInfo={setClosingInfo} />
        </Card.Body>
      </Card>
      <Snackbar open={snackOpen} autoHideDuration={2500} onClose={handleSnackClose} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
        <Alert onClose={handleSnackClose} severity={snackSeverity}>
          {snackText}
        </Alert>
      </Snackbar>

      <ConfirmationModal show={closeConvModal} handleClose={handleCloseConvModal} handleConfirm={handleCloseConversations} />
      {showErxModal && <ERXModal show={showErxModal} onHide={hideErxModal} eRxid={eRxid} />}
    </>
  );
};

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const ConfirmationModal = ({ show, handleClose, handleConfirm }) => {
  const [status, setStatus] = useState("");
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);
  return (
    <Modal show={show} onHide={() => handleClose()} backdrop={"static"}>
      <Modal.Body>
        <p>Are you sure want to update status?</p>
        <div key={`default-radio`} className="mb-3">
          <Form.Check
            type={"radio"}
            label={`Needs Review`}
            value="NEEDS_REVIEW"
            checked={status === "NEEDS_REVIEW"}
            onChange={e => setStatus(e.target.value)}
            className="mb-2"
          />
          <Form.Check
            type={"radio"}
            label={`In Progress`}
            value="IN_PROGRESS"
            checked={status === "IN_PROGRESS"}
            onChange={e => setStatus(e.target.value)}
            className="mb-2"
          />
          <Form.Check
            type={"radio"}
            label={`Done`}
            value="DONE"
            checked={status === "DONE"}
            onChange={e => setStatus(e.target.value)}
            className="mb-2"
          />
        </div>
        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
          <Form.Label>Reason for this status?</Form.Label>
          <Form.Control as="textarea" rows={3} placeholder="Type in the reason" onChange={e => setReason(e.target.value)} />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button disabled={loading} variant="secondary" onClick={handleClose}>
          CLOSE
        </Button>
        <Button
          variant="light"
          disabled={loading}
          className="message-view-confirm-button"
          onClick={() => handleConfirm(status, reason, setLoading)}
        >
          CONFIRM
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const StatusDone = ({ status }) => {
  return (
    <div
      className="message-view-status-info"
      style={{
        background: status === "DONE" ? "#007F61" : status === "IN_PROGRESS" ? "#BA8719" :
          status === "NEEDS_REVIEW" ? "#FA2F2F" : "white",
      }}
    >
      {status === "DONE" ? (
        <BsFillCheckCircleFill />
      ) : status === "IN_PROGRESS" ? (
        "In Progress"
      ) : status === "NEEDS_REVIEW" ? (
        <BsFillExclamationCircleFill />
      ) : null}
      &nbsp;&nbsp;{status === "DONE" ? "Done" : status === "IN_PROGRESS" ? <BsHourglassSplit /> : status === "NEEDS_REVIEW" ? "Needs Review" : null}
    </div>
  );
};

export default MessageView;
